// Utility global para rate limiting que persiste entre re-renders y hot reloads
class RateLimiter {
  private lastSyncTime: number = 0;
  private ongoingSync: Promise<any> | null = null;
  private readonly MIN_SYNC_INTERVAL = 15000; // 15 segundos (aumentado)
  private static globalCounter = 0;

  canSync(): boolean {
    const now = Date.now();
    const timeSinceLastSync = now - this.lastSyncTime;
    RateLimiter.globalCounter++;
    
    console.log(`🔄 [${RateLimiter.globalCounter}] RateLimiter.canSync(): ${timeSinceLastSync}ms desde última sync (mínimo: ${this.MIN_SYNC_INTERVAL}ms), ongoing: ${!!this.ongoingSync}`);
    
    if (this.ongoingSync) {
      console.log(`🚫 [${RateLimiter.globalCounter}] BLOCKED - Sync en progreso`);
      return false;
    }
    
    const canProceed = timeSinceLastSync >= this.MIN_SYNC_INTERVAL;
    if (!canProceed) {
      console.log(`🚫 [${RateLimiter.globalCounter}] BLOCKED - Rate limit activo (${this.MIN_SYNC_INTERVAL - timeSinceLastSync}ms restantes)`);
    }
    
    return canProceed;
  }

  getRemainingTime(): number {
    const now = Date.now();
    const timeSinceLastSync = now - this.lastSyncTime;
    const remainingTime = this.MIN_SYNC_INTERVAL - timeSinceLastSync;
    return Math.max(0, Math.ceil(remainingTime / 1000));
  }

  async executeSync<T>(syncFunction: () => Promise<T>): Promise<T | null> {
    // Verificación temprana de ongoing sync
    if (this.ongoingSync) {
      console.log('� RateLimiter.executeSync(): BLOCKED - Ya hay sincronización en progreso');
      return null;
    }

    // Verificar rate limiting
    if (!this.canSync()) {
      const remaining = this.getRemainingTime();
      console.log(`� RateLimiter.executeSync(): BLOCKED - ${remaining}s restantes`);
      return null;
    }

    try {
      console.log('✅ RateLimiter.executeSync(): INICIANDO sincronización...');
      
      // Marcar tiempo y estado ANTES de ejecutar
      this.lastSyncTime = Date.now();
      this.ongoingSync = syncFunction();
      
      const result = await this.ongoingSync;
      
      console.log('✅ RateLimiter.executeSync(): Sincronización COMPLETADA exitosamente');
      return result;
    } catch (error) {
      console.error('❌ RateLimiter.executeSync(): ERROR en sincronización:', error);
      throw error;
    } finally {
      // IMPORTANTE: Limpiar el flag de ongoing sync
      this.ongoingSync = null;
      console.log('🔧 RateLimiter.executeSync(): Flags limpiados');
    }
  }

  reset(): void {
    this.lastSyncTime = 0;
    this.ongoingSync = null;
    console.log('🔄 RateLimiter.reset(): Reset completado');
  }

  getStatus(): { lastSync: number, ongoing: boolean, timeSinceLastSync: number, canSyncNow: boolean } {
    const now = Date.now();
    return {
      lastSync: this.lastSyncTime,
      ongoing: !!this.ongoingSync,
      timeSinceLastSync: now - this.lastSyncTime,
      canSyncNow: this.canSync()
    };
  }
}

// Instancia global que persiste entre hot reloads
const globalRateLimiter = new RateLimiter();

export default globalRateLimiter;
